<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 15:47:46
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 15:54:01
-->
<!-- 查询车场支付记录接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure";

  export default {
    name: "",
    components: {
      "right-structure": structure
    },
    props: ["commonUrls"],
    data() {
      return {
        requestBody: {
        },
        responseCode: {

        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台根据车牌号码及支付时间查询车场账单",
          t_url: this.commonUrls.test + "getParkPayBillByCarNosAndPayTime",
          p_url: this.commonUrls.prod + "getParkPayBillByCarNosAndPayTime",
          precondition: "无",
          fitSystem: "VEMS传统停车场, 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [
            {
              titleName: null,
              tabledata: [
                {tableHead: "参数名", tdName: "info1"},
                {tableHead: "是否必填", tdName: "info2"},
                {tableHead: "类型", tdName: "info3"},
                {tableHead: "说明", tdName: "info4"}
              ],
              td: [
                {
                  info1: "parkCodeList",info2: "否",info3: "JSONArray",info4: "停车场编号列表"},
                {
                  info1: "carNoList",info2: "是",info3: "JSONArray",info4: "车牌号码列表"
                },
                {
                  info1: "parkingCodeList",info2: "否",info3: "JSONArray",info4: "停车记录列表"
                },
                {
                  info1: "billCodeList",info2: "否",info3: "JSONArray",info4: "支付订单编号列表"
                },
                {
                  info1: "startTime",info2: "否",info3: "String",info4: "开始时间， yyyyMMddHHmmss"
                },
                {
                  info1: "endTime",info2: "否",info3: "String",info4: "结束时间， yyyyMMddHHmmss"
                },
                {info1: "pageNum", info2: "是", info3: "int", info4: "当前页"},
                {info1: "pageSize",info2: "是",info3: "int",info4: "每页多少条，取值范围：1-100"}
              ]
            }
          ],
          R_params: [
            {
              titleName: null,
              tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
              td: [
                { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                { info1: 'recordList', info2: '是', info3: 'String', info4: '记录列表' },
              ]
            },
           {
              titleName: 'recordList',
              tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
              td: [
                { info1: 'parkName', info2: '否', info3: 'String', info4: '车场名' },
                { info1: 'parkCode', info2: '否', info3: 'String', info4: '车场编码' },
                { info1: 'enterTime', info2: '否', info3: 'String', info4: '进场时间' },
                { info1: 'billCode', info2: '否', info3: 'String', info4: '账单编码' },
                { info1: 'parkingCode', info2: '否', info3: 'String', info4: '停车记录号' },
                { info1: 'thirdBillCode', info2: '否', info3: 'String', info4: '第三方订单号' },
                { info1: 'billOriginType', info2: '否', info3: 'String', info4: '订单来源，0停车场 1,智慧停车 2、开放平台' },
                { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌' },
                { info1: 'cardNo', info2: '否', info3: 'String', info4: '卡号' },
                { info1: 'payTime', info2: '否', info3: 'String', info4: '支付时间' },
                { info1: 'shouldValue', info2: '否', info3: 'BigDecimal', info4: '应付金额' },
                { info1: 'realValue', info2: '否', info3: 'BigDecimal', info4: '实付金额' },
                { info1: 'BigDecimal', info2: '否', info3: 'BigDecimal', info4: '优惠金额' },
                { info1: 'paymentMode', info2: '否', info3: 'String', info4: '支付类型' },
                { info1: 'payOrigin', info2: '否', info3: 'String', info4: '支付来源' },
                { info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付类型备注' },
                { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                { info1: 'tollCollectorName', info2: '否', info3: 'String', info4: '操作人' },
                { info1: 'receiverType', info2: '否', info3: 'String', info4: '接收类型' },
                { info1: 'isArrear', info2: '否', info3: 'String', info4: '是否欠费补缴记录：0否，1是' },
                { info1: 'leaveTime', info2: '否', info3: 'String', info4: '离场时间' },
                { info1: 'parkingDataStatus', info2: '否', info3: 'String', info4: '停车记录数据状态：1正常，0异常' }
           ]
            }
          ],
          codeStatus: [
            {
              titleName: null,
              tabledata: [
                {tableHead: "状态码", tdName: "info1"},
                {tableHead: "说明", tdName: "info2"}
              ],
              td: [
                {info1: "000110", info2: "失败"},
                {info1: "00110000", info2: "失败"},
                {info1: "110000", info2: "失败"}
              ]
            }
          ]
        }
      };
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getParkPayBillByCarNosAndPayTime.vue